<template>
  <div>
    <LazyHydrate when-idle>
      <NonBrowserOverlay />
    </LazyHydrate>
    <MinisiteHeader />
    <section v-if="statusCode === 200" class="content">
      <main id="main" role="main">
        <!-- <nuxt keep-alive :keep-alive-props="{ max: 10 }" /> -->
        <nuxt />
      </main>
    </section>
    <section v-else-if="statusCode === 404">
      <Error404 />
    </section>
    <section v-else-if="statusCode === 500">
      <Error500 />
    </section>
    <MinisiteFooter />
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration'
import { mapGetters } from 'vuex'

export default {
  components: {
    LazyHydrate,
    MinisiteHeader: () => import('~/components/Minisite/MinisiteHeader.vue'),
    MinisiteFooter: () => import('~/components/Minisite/MinisiteFooter.vue'),
    NonBrowserOverlay: () => import('~/components/NonBrowserOverlay.vue'),
    Error404: () => import('~/components/error/404.vue'),
    Error500: () => import('~/components/error/500.vue')
  },
  data() {
    return {
      isHomepage: this.$route.path === '/',
      isFromMobile: this.$ua.isFromIphone() || this.$ua.isFromAndroidMobile(),
      isFromTablet: this.$ua.isFromTablet(),
      showBasket: false,
      showLeft: !(this.$ua.isFromIphone() || this.$ua.isFromAndroidMobile()) && !(this.$ua.isFromAndroidTablet() || this.$ua.isFromTablet()),
      showRight: this.$route.path !== '/' && !(this.$ua.isFromIphone() || this.$ua.isFromAndroidMobile()) && !(this.$ua.isFromAndroidTablet() || this.$ua.isFromTablet())
    }
  },
  computed: {
    getBasket() {
      return this.$store.getters['basket/payload']
    },
    ...mapGetters({
      statusCode: 'UI/statusCode'
    })
  },
  created() {
    this.$nuxt.$on('SHOW_BASKET', value => {
      if (this.showBasket !== value) {
        this.showBasket = value
      }
    })
  },
  beforeDestroy() {
    // $off method will turned off the event listner
    this.$nuxt.$off('SHOW_BASKET')
  }
}
</script>

<style lang="scss"></style>
